import { ClientNutritionStatsDto } from "@growth-machine-llc/stridist-api-client";
import { Box, darken, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { Cell, PolarAngleAxis, RadialBar, RadialBarChart } from "recharts";

const useStyles = makeStyles((theme) => ({
    root: {
        margin: theme.spacing(-0.5),
        fontFamily: theme.typography.fontFamily,
    },
}));

interface ClientNutritionStatsCardProps {
    stats: ClientNutritionStatsDto;
}

export const ClientNutritionStatsCard = (props: ClientNutritionStatsCardProps) => {

    const {palette} = useTheme();

    const s = useStyles();

    const { stats } = props;

    const value = Math.round(stats.completion * 100);

    const lineColor = value < 26 || value > 175 ? palette.progress.red :
        (value > 25 && value < 76) || value > 125 ? palette.progress.yellow :
        value > 75 ? palette.progress.green : palette.text.secondary;

    const chartData = [
        { name: "completion", value: stats?.completion, overflow: Math.max(0, stats?.completion - 1) },
    ]

    const colorTint = 0.08;
    
    return (
        <Box className={s.root}>
            <RadialBarChart
                cx="50%"
                cy="50%"
                height={70}
                width={70}
                margin={{top: -10, right: -10, bottom: -10, left: -10}}
                data={chartData}
                barSize={5}
                innerRadius="60%"
                startAngle={90}
                endAngle={-270}
                barGap={-5}
                >
                    <defs>
                        <pattern
                        id="dotsRed"
                        width="6"
                        height="6"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(45)"
                        >
                        <circle cx="2" cy="2" r="2" stroke="transparent" fill={darken(palette.progress.red, colorTint)} />
                        </pattern>

                        <pattern
                        id="dotsYellow"
                        width="6"
                        height="6"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(45)"
                        >
                        <circle cx="2" cy="2" r="2" stroke="transparent" fill={darken(palette.progress.yellow, colorTint)} />
                        </pattern>

                        <pattern
                        id="dotsGreen"
                        width="6"
                        height="6"
                        patternUnits="userSpaceOnUse"
                        patternTransform="rotate(45)"
                        >
                        <circle cx="2" cy="2" r="2" stroke="transparent" fill={darken(palette.progress.green, colorTint)} />
                        </pattern>
                    </defs>

                    <text
                        x="50%"
                        y="55%"
                        fontSize={12}
                        fontWeight={500}
                        textAnchor="middle"
                        fill={palette.text.primary}
                    >
                        {value}%
                    </text>
                
                    <PolarAngleAxis
                        type="number"
                        domain={[0, 1]}
                        tick={false}
                        angleAxisId={0}
                    />

                    <PolarAngleAxis
                        type="number"
                        domain={[0, 1]}
                        tick={false}
                        angleAxisId={1}
                    />

                    <RadialBar
                        dataKey="value"
                        fill={lineColor}
                        cornerRadius={10}
                        angleAxisId={0}
                        stackId={1}
                        fillOpacity={0.8}
                        animationDuration={500}
                        animationEasing="linear"
                        background={{
                            fill: palette.grey[100],
                            strokeWidth: 3,
                            stroke: palette.background.default,
                        }}
                    />

                    <RadialBar
                        dataKey="overflow"
                        cornerRadius={10}
                        stroke={darken(lineColor, colorTint)}
                        strokeWidth={1}
                        strokeLinecap="round"
                        angleAxisId={1}
                        stackId={1}
                        animationBegin={500}
                        animationDuration={500}
                        animationEasing="linear"
                    >
                        <Cell key="cell-0" fill={`url(#dots${
                            value < 26 || value > 175 ? "Red" :
                            (value > 25 && value < 76) || value > 125 ? "Yellow" :
                            value > 75 ? "Green" : "Green"
                        })`} />
                    </RadialBar>

            </RadialBarChart>
        </Box>
    )
};